<!-- 个人信息 -->
<template>
    <el-row>
      <el-col :span="5" :xs="24" class="layout-left">
        <el-row>
          <el-col :span="24" :xs="8">
            <el-avatar :size="180" :src="leftForm.photoUrl" style="margin: 0 auto;display: block;">
              <i class="el-icon-user-solid"></i>
            </el-avatar>
          </el-col>
          <el-col :span="24" :xs="16">
            <el-form :model="leftForm" ref="ruleForm" label-position="right" label-width="90px"
              class="left-ruleForm demo-ruleForm">
              <el-form-item label="账号：" prop="account">
                <p v-text="leftForm.account"></p>
              </el-form-item>
              <el-form-item label="编号：" prop="userCode">
                <p v-text="leftForm.userCode"></p>
              </el-form-item>
              <el-form-item label="状态：" prop="status">
                <p :style="{'color':leftForm.statuscolor}" v-text="leftForm.statusText"></p>
              </el-form-item>
              <el-form-item label="级别：" prop="status">
                <p v-if="userInfo.user_level" :style="{'color':leftForm.statuscolor}" v-text="userObj.userLevel"></p>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="1" :xs="0" style="text-align: center" class="layout-divider">
        <el-divider direction="vertical"></el-divider>
      </el-col>
      <el-col :span="18" :xs="24" style="position: relative" class="layout-right">
        <div class="title">基本信息</div>
        <el-form :model="leftForm" :rules="rules" ref="ruleForm" label-position="right" label-width="80px"
          class="right-ruleForm demo-ruleForm">
          <el-row>
            <el-col :span="24" :lg="12">
              <el-form-item label="用户名" prop="userName">
                <el-input v-model="leftForm.userName" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" :lg="12">
              <el-form-item label="别名" prop="otherName">
                <el-input v-model="leftForm.otherName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" :lg="12">
              <el-form-item label="身份证号" prop="idno">
                <el-input v-model="leftForm.idno"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" :lg="12">
              <el-form-item label="手机" prop="phone">
                <el-input v-model="leftForm.phone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" :lg="12">
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="leftForm.email"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" :lg="12">
              <el-form-item label="生日" prop="birthday">
                <m-date-picker
                  v-model="leftForm.birthday"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd 00:00:00"
                  placeholder="请选择生日">
                </m-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24" :lg="12">
              <el-form-item label="性别" prop="openId">
                <!-- <el-input v-model="leftForm.sex"></el-input> -->
                <el-radio-group v-model="leftForm.sex">
                  <el-radio :label="1">男</el-radio>
                  <el-radio :label="2">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div v-if="disabled" class="zcr" @click="prompt()"></div>
      </el-col>
    </el-row>
</template>
<script>
  import { updateInfo } from "@/api/system/user"
  import { mapGetters } from "vuex"
  import { getDictionary } from "@/api/system/dict";
  export default {
    name:"info",
    props:{disabled:Boolean,user:Object},
    components: {
    },
    computed: {
      ...mapGetters(["userInfo"]),
    },
    watch:{
      user(val) {
        this.initForm();
      }
    },
    data() {
      
      var validateidno = (rule, value, callback) => {
        //身份证15、18位校验
        let pattern = /(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)/g
        if (value && !pattern.test(value)) {
          callback(new Error("请输入正确的15或18位身份证号码"))
        } else {
          callback()
        }
      }
      var validatephone = (rule, value, callback) => {
        //国内电话或手机号码校验
        let pattern = /^(\d{11})$|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$/g
        if (value && !pattern.test(value)) {
          callback(new Error("请输入正确的电话或手机号码"))
        } else {
          callback()
        }
      }
      var validateemail = (rule, value, callback) => {
        let pattern = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/g
        if (value && !pattern.test(value)) {
          callback(new Error("请输入正确的邮箱地址"))
        } else {
          callback()
        }
      }
      return {
        isShowTip: false,
        leftForm: {},
        activeArr: ['1'],//折叠面板默认打开
        userObj:{},
        rules: {
          idno: [{validator: validateidno}],
          phone: [{validator: validatephone}],
          email: [{validator: validateemail}],
        }
      }
    },
    created() {
      this.obtainInformation();
    },
    mounted() {
    },
    methods: {
      // 提示
      prompt(){
        this.$message({message:"点击右上角的编辑按钮进行编辑操作"});
      },
      // 获取信息
      obtainInformation(){
        getDictionary({ 'code': "SYS_USER_LEVEL" }).then(res=>{
          this.$set(this.userObj,"userLevel",res.data.data.find(i=>{return i.dictKey==this.userInfo.user_level}).dictValue);
        })
      },
      //提交
      handleSubmit(){
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            updateInfo(this.$qs.stringify({
              id: this.leftForm.id,
              userName: this.leftForm.userName,
              otherName: this.leftForm.otherName,
              idno: this.leftForm.idno, // 身份证
              phone: this.leftForm.phone,
              email: this.leftForm.email,
              birthday: this.leftForm.birthday,
              sex: this.leftForm.sex,
            })).then(res=>{
              this.$emit('success');
              this.$message.success("基本信息修改成功，建议退出系统后再进入。");
            },err=>{

            })
          }
        });
      },
      initForm(){
        this.leftForm = {
          account: this.user.account,
          userCode: this.user.userCode,
          statusText: this.user.statusText,
          statuscolor: this.user.statuscolor,
          id:this.user.id,
          photoUrl: this.user.photoUrl,
          userName: this.user.userName,
          otherName: this.user.otherName,
          idno: this.user.idno,
          phone: this.user.phone,
          email: this.user.email,
          birthday: this.user.birthday,
          sex: this.user.sex,
        };

      },
      clearValidateorForm(){
        this.$refs.ruleForm.clearValidate()
        this.initForm();
      }
    },
  }
</script>

<style lang="scss" scoped>
@media screen and (min-width: 989px) and (max-width:1160px),screen and (min-width: 768px) and (max-width:900px) {
  .layout-left{
    width: 25%;
  }
  .layout-divider{
    width: 5%;
  }
  .layout-right{
    width: 70%;
  }
}
@media only screen and (min-width: 768px){
  .layout-left{
    margin: 10px 0 !important;
  }
  .left-ruleForm{
    /deep/.el-form-item {
      display: flex;
      justify-content: center;
    }
    /deep/.el-form-item__content{
      margin-left: 0px !important;
      width: 100px;
    }
  }
}
.el-icon-user-solid{
  font-size: 160px;
}

  /deep/.el-aside {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }

  .avatar-tip {
    width: 100%;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    color: #fff;
  }

  /deep/.el-col {
    margin-bottom: 0px !important;
  }

  /deep/.el-collapse-item__header {
    height: 48px;
    line-height: 48px;
    color: #303133;
    font-size: 16px;
    font-weight: 600;
    background-color: #EBEEF5;
  }

.title{
  height: 48px;
  line-height: 48px;
  color: #303133;
  padding: 0 30px;
  font-size: 16px;
  font-weight: 600;
  background-color: #EBEEF5;
}

.zcr{
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 1;
}

  .demo-ruleForm {
    /deep/.el-form-item {
      margin-bottom: 0px;
    }
    /deep/.el-input__inner {
      background-color: #fff;
      border: none
    }
    /deep/.el-form-item__label{
      padding: 0 6px 0 0;
    }
  }
  .right-ruleForm {
    /deep/.el-input__inner {
      border-bottom: 1px solid #DCDFE6;
    }
  }
  /deep/ .el-date-editor{
    width: 100% !important;
  }
  /deep/.el-divider--vertical {
    min-height: 300px !important;
  }
  /deep/.el-form-item__error {
    font-size: 14px;
    top: 54%;
}
</style>
